import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  Checkbox,
} from "@material-ui/core";
import ModalBills from "../BillsFilter/ModalBills";

const BillsFilter = ({
  selectedList,
  showOnlySelectedCounters,
  showOnlySelectedCountersChanged,
  filterResult,
  projects,
  counterList,
  projectSelected,
  selectProjectChange,
  counterSelected,
  modalStatus,
}) => {
  return (
    <>
      <ModalBills
        open={modalStatus}
        pid={projectSelected.value}
        tid={counterSelected.value}
        selectedList={selectedList.value}
      />
      <div className="container">
        <div className="bills-filter">
          <div className="select-project-wrapper">
            <FormControl sx={{ m: 1, minWidth: 80 }}>
              <InputLabel id="select-project-label">انتخاب پروژه</InputLabel>
              <Select
                labelId="select-project-label"
                id="select-project"
                value={projectSelected.value}
                fullWidth
                label="انتخاب پروژه"
                onChange={selectProjectChange}
              >
                <MenuItem value="">
                  <em>پروژه مورد نظر را انتخاب کنید.</em>
                </MenuItem>
                {projects.value.map((item) => (
                  <MenuItem value={item.water_meter_project_id}>
                    {item.water_meter_project_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="select-project-wrapper">
            <FormControl sx={{ m: 1, minWidth: 80 }}>
              <InputLabel id="select-types-counter-label">
                انتخاب نوع کنتور
              </InputLabel>
              <Select
                labelId="select-types-counter-label"
                id="select-types-counter"
                value={counterSelected.value}
                fullWidth
                label="انتخاب نوع کنتور"
                disabled={!counterList.value.length}
                onChange={(e) => counterSelected.handleChange(e.target.value)}
              >
                <MenuItem value="">
                  <em>نوع کنتور را انتخاب نمایید.</em>
                </MenuItem>
                {counterList.value.map((item) => (
                  <MenuItem value={item.id}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="btn-submit">
            <Button variant="contained" color="primary" onClick={filterResult}>
              جست و جو
            </Button>
          </div>
        </div>
      </div>
      {renderOnlyShowSelectedCounters(
        showOnlySelectedCounters.value,
        showOnlySelectedCountersChanged,
        selectedList,
        modalStatus
      )}
    </>
  );
};

const renderOnlyShowSelectedCounters = (
  showOnlySelectedCounters,
  showOnlySelectedCountersChanged,
  selectedList,
  modalStatus
) => {
  return (
    <Grid
      item
      style={{
        paddingRight: "8px",
        paddingLeft: "8px",
        marginBottom: "24px",
        marginTop: "12px",
      }}
      sx={12}
      sm={12}
      md={12}
      lg={12}
    >
      <Grid
        style={{ fontSize: "14px", color: "#73879c" }}
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid style={{ marginLeft: "2px" }} item>
          <Checkbox
            onChange={showOnlySelectedCountersChanged}
            color="primary"
            checked={showOnlySelectedCounters.value}
          />
          <span style={{ fontWeight: "bold" }}>
            تنها موارد انتخاب شده را نمایش بده
          </span>
        </Grid>
        {/* <Grid item>
         
        </Grid> */}
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            disabled={selectedList.value.length === 0}
            onClick={() => {
              if (selectedList.value.length > 0) {
                modalStatus.handleChange(true);
              }
            }}
          >
            صدور قبض
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BillsFilter;
